import React from 'react';
import FactorTabLayout from '../shared/FactorTabLayout';
import { getTab } from '../config';

/**
 * Consumer price index and inflation trends.
 *
 * Currently the shared factor layout with nothing extra. Add tab-specific
 * sections as children of FactorTabLayout - they stay isolated to this file.
 */
const CpiTab = ({ data, period }) => (
  <FactorTabLayout tab={getTab('cpi')} data={data} period={period} />
);

export default CpiTab;
